import { getAxiosInstance, getQueryStringFromObject } from "./common.service";

async function getArtists(query = {}) {
    try {
        const axios = await getAxiosInstance();
        let queryString = await getQueryStringFromObject(query);
        if (queryString) {
            queryString = '?' + queryString;
        } else {
            queryString = '';
        }
        let response = await axios.get('/artists' + queryString);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

async function postArtistAnswer(data) {
    try {
        const axios = await getAxiosInstance();
        let response = await axios.post('/artist_answers', data);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

// async function getBonusPoints(data) {
//     try {
//         const axios = await getAxiosInstance();
//         let response = await axios.post('/points/calculate/bonus', data);
//         return response.data;
//     } catch (error) {
//         console.error(error);
//     }
// }

async function getPoints(data) {
    try {
        const axios = await getAxiosInstance();
        let group_id = data.group_id;
        let song_id = data.song_id;
        let response = await axios.get('/points/groups/'+group_id+'/songs/'+song_id);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}


export {
    getArtists,
    postArtistAnswer,
    // getBonusPoints,
    getPoints
}
